import React from 'react'
import { FaFacebookF, FaInstagram, FaLinkedin, FaYoutube } from 'react-icons/fa6'

function Footer() {
    return (
        <div className='bg-default-gray text-dark-gray py-10 p-2 mt-20'>
            <div className='flex flex-col lg:flex-row justify-evenly gap-x-12 p-4 max-w-[108rem] grid-rows-2 mx-auto'>

                <div className='flex flex-col p-5 lg:p-0 md:max-w-[20rem]'>
                    <img src='./assets/icons/logo.svg' alt='logo' className='w-24 h-24' />
                    <p className='mt-5 text-sm'>
                        We aim to continue evolving as a center of excellence, inspiring students to realize their full
                        potential and succeed on a global scale. Our future initiatives include expanding our resources,
                        incorporating modern
                    </p>
                </div>

                <div className='flex flex-col p-5 lg:p-0 '>
                    <h3 className='text-medium font-bold'>Quick Links</h3>
                    <ul className='mt-4'>
                        <li className='mb-2 text-sm'><a href='/'>Home</a></li>
                        <li className='mb-2 text-sm'><a href='/about'>About</a></li>
                        <li className='mb-2 text-sm'><a href='/programs-and-courses'>Programs</a></li>
                        {/* <li className='mb-2 text-sm'><a href='/community'>Community</a></li> */}
                    </ul>
                </div>
                <div className='flex flex-col p-5 lg:p-0 '>
                    <h3 className='text-medium font-bold'>Support</h3>
                    <ul className='mt-4'>
                        {/* <li className='mb-2 text-sm'><a href='/help'>Help Center</a></li> */}
                        <li className='mb-2 text-sm'><a href='/webinars'>Webinars</a></li>
                        {/* <li className='mb-2 text-sm'><a href='/feedbacks'>Feedbacks</a></li> */}
                    </ul>
                </div>
                <div className='flex flex-col p-5 lg:p-0 '>
                    <h3 className='text-medium font-bold'>Links</h3>
                    <ul className='mt-4'>
                        <li className='mb-2 text-sm'><a href='/login'>Student Portal</a></li>
                        <li className='mb-2 text-sm'><a href='/admission-form'>Enroll Now</a></li>
                        <li className='mb-2 text-sm'><a href='/blog'>Blog</a></li>
                        <li className='mb-2 text-sm'><a href='/contact'>Contact</a></li>
                    </ul>
                </div>
                <div className='flex flex-col p-5 lg:p-0 '>
                    <h3 className='text-medium font-bold'>Contact Us</h3>
                    <ul className='mt-4'>
                        <li className='mb-2 text-sm'><a href='tel:+94 70 31 32 302'>+94 70 31 32 302</a></li>
                        <li className='mb-2 text-sm'><a href='tel:+94 76 37 06 240'>+94 76 37 06 240</a></li>
                        <li className='mb-2 text-sm'><a href='mailto:info@oxfordcollege.lk'>info@oxfordcollege.lk</a></li>
                        <li className='mb-2 text-sm'><a href='/webinars'>200A 1/1, Sandares Mawatha,
                            <br />
                            Ihalagama, Gampaha</a></li>
                    </ul>
                    <div className='flex items-center mt-3 gap-x-2 text-xl'>
                        <div className='bg-blue-600 w-fit aspect-square p-1 text-white rounded-md'>
                            <a target='_blank' rel='noreferrer' href='https://www.facebook.com/OxfordCollegeGampaha'><FaFacebookF /></a>
                        </div>
                        <div
                            className='w-fit aspect-square p-1 text-white rounded-md bg-gradient-to-tr from-yellow-400 via-pink-600 to-blue-600'>
                            <FaInstagram />
                        </div>
                        <div className='bg-red-500 w-fit aspect-square p-1 text-white rounded-md'>
                            <a target='_blank' rel='noreferrer' href='https://www.youtube.com/@OxfordCollegeGampaha'><FaYoutube /></a>
                        </div>
                        <div className='bg-blue-400 w-fit aspect-square p-1 text-white rounded-md'>
                            <FaLinkedin />
                        </div>
                    </div>
                </div>
            </div>
            <p className='text-center text-sm mt-10'>Copyright © Oxford College Gampaha. All rights reserved. <br />
                Web design by <a className='cursor-pointer font-semibold' href="https://www.gbsweb.net/">GBS (Pvt) Ltd</a></p>
        </div>
    )
}

export default Footer